module.exports = __webpack_public_path__ + "static/media/mood_2.eca4e6ae.svg";